import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "sc_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) {
    const first = d[0];
    const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : "";
    return `${field ? field + ": " : ""}${first.msg}`;
  }
  return fallback;
};

export async function streamTutor(sessionId, content, mode, onDelta) {
  const headers = { "Content-Type": "application/json" };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const res = await fetch(`${API_BASE}/tutor/sessions/${sessionId}/messages`, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify({ content, mode }),
  });
  if (!res.ok || !res.body) throw new Error("Tutor is unavailable right now");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let full = "";
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.trim();
      if (!line.startsWith("data:")) continue;
      try {
        const ev = JSON.parse(line.slice(5).trim());
        if (ev.delta) {
          full += ev.delta;
          onDelta(full);
        }
        if (ev.error) throw new Error(ev.error);
      } catch (err) {
        if (err instanceof SyntaxError) continue;
        throw err;
      }
    }
  }
  return full;
}

export const GRADE_BANDS = ["Pre-K", "K-2", "3-5", "6-8", "9-12", "College"];
export const GRADE_LABELS = {
  "Pre-K": "Pre-K (ages 3-5)",
  "K-2": "Grades K-2",
  "3-5": "Grades 3-5",
  "6-8": "Grades 6-8",
  "9-12": "Grades 9-12",
  College: "College",
};
export const SUBJECTS = ["Math", "Reading", "Writing", "Science", "History", "Social Studies", "Geography", "Social Science", "Economics", "Computer Science", "Art & Music", "Art", "Music", "Health", "Foreign Language"];
